import React, { useEffect, useState } from 'react';
import { WatchlistApi } from '@apply/api';

import { applicationInsights } from '../../ApplicationInsights';
import { handleAdminError } from '../../common/SharedFunctions';

const CurrentWatchlistBreakdownTable = ({ summaryTypeId }) => {
    const [data, set_data] = useState([]);
    const [totalWatchlist, set_totalWatchlist] = useState(0);
    const watchlistApi = new WatchlistApi.WatchlistApi(applicationInsights);
    const today = new Date();
    const loadSummaryAsync = async (summaryTypeId) => {
        try {
            const response = await watchlistApi.getWatchListSummary(summaryTypeId);
            if (response.statusCode !== 200) {
                throw new Error('Failed to retrieve data!');
            }
            const records = response.result;
            set_data(records.data);
            set_totalWatchlist(records.totalCount);
        } catch (ex) {
            handleAdminError(ex, 'Failed to retrieve records! Please refresh the page and try again.');
        }
    };
    useEffect(() => {
        if (isNaN(summaryTypeId)) {
            return;
        }
        loadSummaryAsync(summaryTypeId);
    }, [summaryTypeId]);
    const style = {
        floatRight: {
            float: 'right',
        },
        header: {
            margin: '.2rem',
            display: 'flex',
            float: 'left',
        },
        blockParent: {
            border: '1px solid lightgrey',
        },
        child: {
            paddingLeft: '5px',
            paddingRight: '5px',
        },
        footer: {
            borderTop: '1px solid lightgrey',
            backgroundColor: 'whitesmoke',
            paddingLeft: '5px',
            paddingRight: '5px',
        },
    };
    return (
        <div style={style.blockParent}>
            <p>
                Summary as of {today.getMonth() + 1}/{today.getDate()}/{today.getFullYear()}
            </p>
            <div
                style={{
                    display: 'grid',
                }}
            >
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>Non-Accrual:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === 'Non-Accrual')?.count || 0
                        }
                    </span>
                </div>
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>90+ Days Default:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === '90+ Days in Default')?.count || 0
                        }
                    </span>
                </div>
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>60+ Days Default:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === '60+ Days in Default')?.count || 0
                        }
                    </span>
                </div>
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>30+ Days Default:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === '30+ Days in Default')?.count || 0
                        }
                    </span>
                </div>
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>Payment Issue:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === 'Payment Issue')?.count || 0
                        }
                    </span>
                </div>
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>Title In Escrow:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === 'FDILA')?.count || 0
                        }
                    </span>
                </div>
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>Non-Standard Accrual:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === 'Non-Standard Accrual (Extended Interest Deferral)')?.count || 0
                        }
                    </span>
                </div>
                <div style={style.child}>
                    {' '}
                    <span style={style.header}>Regular Watchlist:</span>
                    <span style={style.floatRight}>
                        {
                            // @ts-ignore
                            data.find((x) => x.key === 'Regular Watchlist')?.count || 0
                        }
                    </span>
                </div>

                <div style={style.footer}>
                    <span style={style.header}>Watchlist Total:</span>
                    <span style={style.floatRight}>{totalWatchlist}</span>
                </div>
            </div>
        </div>
    );
};

export default CurrentWatchlistBreakdownTable;
